import { observer } from 'mobx-react-lite'
import { RejectMergeDialog } from '@/features/admin/account-linking/RejectMergeDialog'
import { type RejectMergeDialogViewModel } from './RejectMergeDialogViewModel'

export interface RejectMergeDialogContainerProps {
  vm: RejectMergeDialogViewModel
}

export const RejectMergeDialogContainer = observer(
  function RejectMergeDialogContainer({ vm }: RejectMergeDialogContainerProps) {
    return (
      <RejectMergeDialog
        showing={vm.modal.showing}
        onClose={vm.cancel}
        onReject={vm.reject}
        isRejectPending={vm.reject.pending}
        customerDisplayName={vm.customerDisplayName}
      />
    )
  },
)
